import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AccessPolicyService } from '../services/access-policy.service';
import { permittedLandingPath } from './dashboard-access.guard';

export const reportAccessGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  const router = inject(Router);

  return accessPolicy.canReadReports()
    ? true
    : router.createUrlTree([permittedLandingPath(accessPolicy)]);
};

export const reportRunGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  const router = inject(Router);

  return accessPolicy.canRunReports()
    ? true
    : router.createUrlTree([permittedLandingPath(accessPolicy)]);
};
